import Request from '@/api/request';
import { IStatementListItem } from '@/utils/types';

const api = new Request('lk/statement/');

export function userAddSigStatements(
    pageNumber: number,
    pageSize: number
): Promise<IStatementListItem> {
    const url = `userAddSigStatements?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return api.get(url).then((res: any) => {
        return res;
    });
}

export function statementXmlBase64(id: string): Promise<string> {
    return api
        .get(`statementXmlBase64?statementId=${id}`)
        .then((res: any) => res);
}

export function saveAdditionalSignature(data: any): Promise<object> {
    return api.post('saveAdditionalSignature', data).then((res: any) => res);
}